import React, { Fragment, useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { postLoginApi } from "../../service/RestApiService";
import { getErrorMessage } from "../../service/CommonUtils";
import picture from "../../assets/register.jpg";
import pic from "../../assets/Cimas-Logo.svg";
import { UserOutlined, MailOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import verify from "jwt-decode";
import { Input, Form, Button, notification } from "antd";
import useAuth from "../../Hooks/useAuth";
import { Link } from "react-router-dom";

function ForgetPassword() {
  const [form] = Form.useForm();
  const location = useLocation();

  const { setAuth }: any = useAuth();

  const Context = React.createContext({
    name: "Default",
  });

  const [api, contextHolder] = notification.useNotification();

  const openNotificationSuccess = (placement, message) => {
    api.success({
      message: message,
      description: <Context.Consumer>{({ name }) => ``}</Context.Consumer>,
      placement,
      duration: 10,
    });
  };

  const openNotificationError = (placement, message) => {
    api.error({
      message: message,
      description: <Context.Consumer>{({ name }) => ``}</Context.Consumer>,
      placement,
      duration: 10,
    });
  };

  const super_admin = location.state?.from?.pathname || "/admin/dashboard";
  const admin = location.state?.from?.pathname || "/corporate/dashboard";
  const users = location.state?.from?.pathname || "/";
  const [user, setUser] = useState("");
  const signupMutate = useMutation({
    mutationFn: postLoginApi,
    onSuccess: (data) => {
      const accessToken = data?.accessToken;
      const token: any = verify(accessToken);
      const role = token["Granted_Authorities"][0]["role"];
      const userId = token["sub"];
      setUser("");
      setAuth({ user, role, accessToken, userId });

      const userInfo = {
        token: data?.accessToken,
        role: role,
        userId: userId,
        refresh_token: data?.refreshToken,
      };
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      if (role === "USER") {
        window.location.replace(admin);
      } else if (role === "SUPER_ADMIN") {
        window.location.replace(super_admin);
      } else {
        window.location.replace(users);
      }
    },
    onError: (error) => {
      openNotificationError("topRight", `${getErrorMessage(error)}`);
    },
  });

  const onSubmitForm = async (values: any) => {
    const username = values?.username;
    const password = values?.password;
    const request = {
      username: username,
      password: password,
    };
    signupMutate.mutate(request);
  };

  return (
    <Fragment>
      <div
        style={{
          backgroundImage: `url(${picture})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div
          className="darkbg"
          style={{
            background:
              "linear-gradient(159deg, rgba(3,105,161,1) 0%, rgba(255,255,255,0) 100%)",
            backgroundRepeat: "no-repeat",
            objectFit: "contain",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundAttachment: "fixed",
            overflow: "auto",
            height: "100vh",
          }}
        >
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm col-md col-lg d-flex justify-content-center pt-5">
                <h1
                  className="text-white"
                  style={{ fontWeight: "bolder", fontSize: "40px" }}
                >
                  Corporate Forget Password
                </h1>
              </div>
            </div>
            {contextHolder}
            <div className="row">
              <div className="col-sm-0 col-md-0 col-lg">&ensp;</div>
              <div className="col-sm-12 col-md-12 col-lg m-2">
                <div className="bg-white shadow-lg rounded-4">
                  <div
                    style={{
                      borderRadius: "15px 15px 0px 0px",
                      background: "#8A8C8C",
                    }}
                    className="text-center  p-5"
                  >
                    <div className="row d-flex justify-content-center">
                      <img
                        className="mt-2"
                        src={pic}
                        width={70}
                        height={70}
                        alt="logo"
                      />
                    </div>
                  </div>
                  <Form
                    hideRequiredMark
                    form={form}
                    layout="vertical"
                    onFinish={onSubmitForm}
                  >
                    <div className="row">
                      <div className="col-sm col-md col-lg">
                        <div className="p-5">
                          <div className="row">
                            <label className="login-social-icon mt-4">
                              <h5 className="fw-bold">Forget Password</h5>
                            </label>
                          </div>

                          <div className="row">
                            <div className="co-sm col-md col-lg">
                              <Form.Item
                                className="py-2 m-0"
                                label="Enter your email address"
                                name={"username"}
                                rules={[
                                  {
                                    required: true,
                                    message: "Email address is required field",
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Email address one or two"
                                  prefix={<MailOutlined />}
                                />
                              </Form.Item>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="co-sm col-md col-lg p-3 d-flex justify-content-center">
                        <Button
                          style={{
                            width: "75%",
                            background: "#0369a1",
                            color: "#fff",
                          }}
                          htmlType="submit"
                          className="btn rounded-5 fw-bold"
                        >
                          Submit
                          {signupMutate.isPending ? (
                            <span
                              role="status"
                              aria-hidden="true"
                              className="spinner-border spinner-border-sm ms-2"
                            ></span>
                          ) : (
                            ""
                          )}
                        </Button>
                      </div>
                    </div>

                    <div className="row">
                      <div className="co-sm col-md col-lg  d-flex justify-content-end">
                        <Link
                          className="m-2"
                          to={`${process.env.PUBLIC_URL}/corporate/login`}
                        >
                          Sign/log In?
                        </Link>
                      </div>
                    </div>
                  </Form>
                </div>
              </div>

              <div className="col-sm-0 col-md-0 col-lg">&ensp;</div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

export default ForgetPassword;
